import styled from '@emotion/styled';

const Second:React.FC<any> = () => {
  return (
    <Container>
      <BodyImgContainer>
        <Img src="/images/newLanding/landingApp/368722022.png"/>
      </BodyImgContainer>
      <TextContainer>
        <Text1>
          <span>인화사진만 따로,&nbsp; </span> 갤러리 저장
        </Text1>
        <SmallText>
        포티페타로 인화한 사진은
        <br/>클라우드와 앨범으로 평생 보관하세요
        </SmallText>
      </TextContainer>
    </Container>
  )
};

export default Second;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BodyImgContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const Img = styled.img`
  width: 100%;
`;


const Text1 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;

  span {
    font-weight: 600;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  background-color: #fcf7ef;
  display: flex;
  flex-direction: column;
`


const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 140px;
  text-align: center;
`